import { handleActions } from 'redux-actions';

import { actionTypes, PARTITION, ACTION_PREFIX } from './constants';
import { CheckOut } from '../../types';
import { getActionOptions } from '../../lib/reduxActionsUtils';

export type ReduxState = {
  qsParamsCheckOutId: string | undefined;
  checkOut: CheckOut | any;
};

const initialState: ReduxState = {
  qsParamsCheckOutId: undefined,
  checkOut: undefined,
};

const reducer = handleActions(
  {
    [actionTypes.SET_CHECKOUT_ID]: (state: any, { payload }) => ({
      ...state,
      qsParamsCheckOutId: payload,
    }),
    [actionTypes.GET_CHECKOUT_FULLFILLED]: (state: any, { payload }) => ({
      ...state,
      checkOut: payload.data,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX)
);

export default {
  [PARTITION]: reducer,
};
